var map = {
	"./404.svg": "a14a",
	"./approve.svg": "7502",
	"./area.svg": "22c9",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clean.svg": "1bce",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dakai.svg": "668f",
	"./dashboard.svg": "f782",
	"./data.svg": "5a0a",
	"./documentation.svg": "90fb",
	"./down.svg": "d681",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./epidemic.svg": "d6aa",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./fire.svg": "1278",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./home.svg": "6bbe",
	"./house.svg": "4147",
	"./icon.svg": "9d91",
	"./in_out.svg": "ddec",
	"./inspector.svg": "1ab2",
	"./international.svg": "17df",
	"./laji.svg": "f1f0",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./mall.svg": "155f",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./order.svg": "11ff",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./popUp.svg": "fb49",
	"./qq.svg": "1430",
	"./redCode.svg": "4614",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./shouqi.svg": "6d25",
	"./shuidi.svg": "796c",
	"./sign.svg": "2496",
	"./size.svg": "8644",
	"./star.svg": "708a",
	"./system.svg": "30a9",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree.svg": "93cd",
	"./up.svg": "1380",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";